<template>
  <!-- KV配置页面 -->
  <div id="agentKvConfig">
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <!--KV值-->
          <b-form-group class="find-middle user-id">
            <label>
              {{ $t("lanV4.agentKey") }}
            </label>
            <b-form-input
              v-model.trim="agentKey"
              maxLength="200"
              placeholder=""
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="3" class="header-right-btn">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                    <use xlink:href="#icon-v4_17"></use>
                  </svg> -->
              {{ $t("common.search") }}</b-button
            >
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                    <use xlink:href="#icon-v4_3"></use>
                  </svg> -->
              {{ $t("common.reset") }}</b-button
            >
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
              class="float-left"
              v-if="pages.total > 0"
              :total-rows="pages.total"
              :perPage="pages.size"
              :pageOptions="pages.options"
              :currentPage="pages.page"
              @initialize="pageChange"
              layout="total,sizes"
            >
            </v-page> -->
        <!-- 导出 -->
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table
            :height="$store.state.baseData.tableH"
            class="table-container"
            :data="tableList"
            @sort-change="sortChanged"
            :cell-class-name="addEnClass"
            :default-sort="{ prop: '', order: 'descending' }"
          >
            <template slot="empty">
              <load-skeleton
                v-show="loading"
                :columns="6"
                :rows="10"
                :haveLeftNumber="false"
              ></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>
            <!--  序号 -->
            <el-table-column
              prop="sort"
              align="left"
              :label="$t('common.sort')"
              width="150"
            >
            </el-table-column>
            <!--  key值-->
            <el-table-column
              prop="key"
              align="right"
              :label="$t('lanV4.agentKey')"
         
            >
            </el-table-column>
            <!--  value值-->
            <el-table-column
              prop="value"
              align="right"
              :label="$t('lanV4.agentValue')"
              
            >
            </el-table-column>
            <!--  描述-->
            <el-table-column
              prop="desc"
              align="right"
              :label="$t('lanV4.agentDesc')"
            >
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
              prop="action"
              :label="$t('common.find')"
              fixed="right"
              align="right"
            >
              <template slot-scope="scope">
                <!-- 编辑 -->
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="handleEdit(scope.row)"
                >
                  {{ $t("common.editor") }}
                </b-button>
              </template>
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page
            v-if="pages.total > 0"
            :total-rows="pages.total"
            :perPage="pages.size"
            :pageOptions="pages.options"
            :currentPage="pages.page"
            @initialize="pageChange"
          ></v-page>
        </b-col>
      </b-row>
    </b-card>
    <!-- 返现比例更改弹窗 -->
    <b-modal
      v-model="modalShow"
      :title="$t('common.editor')"
      centered
      scrollable
      no-close-on-backdrop
      @hide="onReset"
    >
      <div id="agentKvConfigModal" class="body-content agentModal">
        <!-- key值 -->
        <b-row class="line">
          <b-col>
            <label>
              <i class="text-danger">*</i>{{ $t("lanV4.agentKey") }}
            </label>
            <b-input-group>
              <b-form-input
                class="append-input"
                v-model.trim="form.agentKey"
                autocomplete="off"
                :disabled="true"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <!-- value值 -->
        <b-row class="line">
          <b-col>
            <label>
              {{ $t("lanV4.agentValue") }}
            </label>
            <b-form-textarea
              style="width: 100%; height: 112px !important"
              id="textarea"
              placeholder=""
              maxLength="500"
              v-model.trim="form.agentVal"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <!-- 描述-->
        <b-row class="line">
          <b-col>
            <label>
              <i class="text-danger">*</i>{{ $t("lanV4.agentDesc") }}
            </label>
            <b-form-textarea
              style="width: 100%; height: 112px !important"
              id="textarea"
              placeholder=""
              v-model.trim="$v.form.agentDesc.$model"
              :state="chkState('agentDesc')"
            ></b-form-textarea>
            <!-- 请输入描述 -->
            <p v-if="!$v.form.agentDesc.required" class="text-danger">
              {{ $t("lanV4.agentDescErr") }}
            </p>
          </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="primary" @click="handleSubmit">{{
          $t("common.save")
        }}</b-button>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
 <script>
import { requiredIf } from "vuelidate/lib/validators";
import commonMixin from "@/mixin/common/commonMixin";
export default {
  name: "agentKvConfig",
  mixins: [commonMixin],
  components: {},
  data() {
    return {
      agentKey: null, // key
      modalShow: false,
      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      form: {
        agentKey: null,
        agentVal: null,
        agentDesc: null,
      },
      notData: true,
      loading: true,
      tableList: [],
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "", //默认排序字段
      sortSet: 1, //默认倒序
      addSave: false,
      submitFlag: true, //提交防连点
    };
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError;
    },
  },
  watch: {
    agentKey(v) {
      if (v) {
        this.$nextTick(() => {
          //   this.agentKey = fixInput(v, 0,{num:1});
        });
      }
    },
  },
  validations: {
    form: {
      // 描述
      agentDesc: {
        required: requiredIf(function () {
          return this.addSave;
        }),
      },
    },
  },
  created() {
    this.getData();
  },

  methods: {
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "value":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },
    // 搜索
    query() {
      this.pages.page = 1;
      this.loading = true;
      this.getData();
    },
    // 重置
    reset() {
      this.agentKey = null;
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        key: this.agentKey,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
      };
      this.$http({
        url: this.$store.state.url.agent.kv_list,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data.pageInfo);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { total, rows } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (rows && rows.length) {
        rows.map((item, index) => {
          arr.push({
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            key: item.key,
            value: item.value,
            desc: item.desc,
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },

    // 提交
    handleSubmit() {
      this.addSave = true;
      if (!this.validate()) {
        return false;
      }

      if (!this.submitFlag) {
        return;
      }
      this.submitFlag = false;
      this.$http({
        url: this.$store.state.url.agent.kv_set,
        params: {
          key: this.form.agentKey,
          value: this.form.agentVal,
          desc: this.form.agentDesc,
        },
      }).then(({ code, msg }) => {
        this.submitFlag = true;
        if (code.toString() === "0") {
          this.$bus.$emit("alert", { type: "success", message: msg });
          this.getData();
          this.modalShow = false;
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    //编辑
    handleEdit(row) {
      this.modalShow = true;
      this.form.agentKey = row.key;
      this.form.agentVal = row.value;
      this.form.agentDesc = row.desc;
    },
    onReset() {
      this.modalShow = false;
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
  },
};
</script>
      
 <style lang="scss">
#agentKvConfig {
  .custom-control {
    top: 5px !important;
  }
}
</style>
      